import React, { Component } from "react";
import { observer } from "mobx-react";
import { Web3Store } from "../stores/web3Store";
import { IMintIPInfo, IMythServerResponse } from "../bean/ResponseBean";
import { Button, Input, Progress, Space } from "antd";
import nftBg from "../images/bg-nft-detail.png";
import { CheckCircleFilled, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import EthSvg from "../components/connectWalletModal/ethSvg";
import { DerivativeWorkStatus, LicensedNFTStatus, MythServerResultCode } from "../constant/CommonConstant";
import logger from "../logger";
import {finneyToEth, getQueryString, handleNFTName} from "../utils/commonUtils";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Autoplay, Pagination } from "swiper";
import "swiper/swiper.less";
import 'swiper/modules/pagination/pagination.less';
import "../styles/mintIPInfo.less"
import BackToPreviousPage from "../components/backPreviousPage";


interface IProps {
    web3Store: Web3Store
}

interface IStates {
    buyNum: number,
    remainSellTokensNumber: number,
    totalPrice: number,
    buying: boolean,
    mintIPInfo: IMintIPInfo,
    ipId: number,
    licensedNFT: boolean
}

@observer
class MintIPInfo extends Component<IProps, IStates> {

    constructor(props: IProps, state: IStates) {
        super(props);
        let ipId = 0;
        let licensedNFT = '';
        try{
            ipId = parseInt(getQueryString("ipId"));
            licensedNFT = getQueryString("licensedNFT");
        }catch (e) {
            console.log(e)
        }
        this.state = {
            ipId: ipId,
            licensedNFT: licensedNFT.toLowerCase() === "true".toLowerCase() ? true : false,
            buyNum: 1,
            remainSellTokensNumber: 100,
            buying: false,
            totalPrice: 0,
            mintIPInfo: {
                ipId: 0,
                artist: undefined,
                derivativeMintInfo: undefined,
                licenseCollectionName: "",
                licenseCollectionAddress: "",
                licenseCollectionLogo: "",
                licensedNFTokenId: "",
                licensedNFTImage: "",
                licensedTime: "",
                licensedMethod: "",
                LicensingPeriod: 0,
                totalSupply: 0,
                price: 0,
                status: 0,
                licensedNFT: false
            }
        }
    }

    componentDidMount(): void {
        this.getMintIPInfo();
    }

    getMintIPInfo = async () => {
        const { web3Store } = this.props;
        const { ipId, licensedNFT } = this.state;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<IMintIPInfo> = await web3Store.mythServerApi.getMintIPInfo(ipId, licensedNFT);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        data.price = finneyToEth(data.price);
                        this.setState({
                            mintIPInfo: data
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    inputCount = (event: any) => {
        const { remainSellTokensNumber, mintIPInfo } = this.state;
        let value = event.target.value;
        const regExp = /^[0-9]\d*$/;
        if (value === '') {
            value = '0';
        }
        if (!regExp.test(value)) {
            return;
        }
        const num = Number.parseInt(value);
        if (num > remainSellTokensNumber) {
            return;
        }
        this.setState({
            buyNum: num,
            totalPrice: num * mintIPInfo.price
        })
    };

    changeBuyNum = (input: number) => {
        const { remainSellTokensNumber, buyNum, mintIPInfo } = this.state;
        const num = buyNum + input;
        if (num > remainSellTokensNumber || num < 1) {
            return;
        }
        this.setState({
            buyNum: num,
            totalPrice: num * mintIPInfo.price
        })
    };

    buyingNFT = () => {

    };

    renderPurchase = () => {
        const { remainSellTokensNumber, mintIPInfo, buyNum, buying, totalPrice } = this.state;
        return <div className="purchase">
            <Progress strokeWidth={20} showInfo={false} strokeColor={"#34c759"}
                percent={remainSellTokensNumber / mintIPInfo.totalSupply * 100} />
            <p className="text-right purchase-count">Total supply: {remainSellTokensNumber}/{mintIPInfo.totalSupply}</p>
            <div className="buy-container text-center flex-row">
                <span>
                    <MinusOutlined className="buy-icon" onClick={() => this.changeBuyNum(-1)} />
                    <Input value={buyNum} onChange={(e) => this.inputCount(e)} defaultValue={1}
                        className="buy-input" />
                    <PlusOutlined className="buy-icon" onClick={() => this.changeBuyNum(1)} />
                </span>
                <span className="eth"><EthSvg size={20} />{totalPrice.toFixed(1)}</span>
                <Button disabled={buyNum < 1} loading={buying} className="myth-button"
                    onClick={() => this.buyingNFT()}>Mint</Button>
            </div>
        </div>
    }

    renderLock = () => {
        return <div className="lock-content flex-row">
            <div className="icon-border">
                <i className="iconfont icon-lock"></i>
            </div>
            <p>The work has not been released as<br /> IP-licensed NFT and cannot be minted.</p>
        </div>
    }

    render() {
        const { mintIPInfo } = this.state;
        // const { TabPane } = Tabs;
        // const copyrightInfo = {
        //     licensedStatus: mintIPInfo.status,
        //     licensedTime: mintIPInfo.licensedTime,
        //     licensedWallet: mintIPInfo.artist?.walletAddress,
        //     collectionLogo: mintIPInfo.licenseCollectionLogo,
        //     collectionName: mintIPInfo.licenseCollectionName,
        //     licensedMode: mintIPInfo.licensedMethod,
        //     nftImage: mintIPInfo.licensedNFTImage,
        //     licensedNFTokenId: mintIPInfo.licensedNFTokenId
        // };
        const unlicensedTips = [
            "All rights and interests of the work belong to the NFT IP holder and the artist. SuperBrands is only for inclusion.",
            "Without the permission of the NFT IP holder or the artist, please do not use it for any commercial purposes.",
            "If you do not want your work to be displayed on SuperBrands, you can send an email to SuperBrandsZY@gmail.com, and we will remove the work after receiving the email."
        ]
        const licensedTips = [
            "This work has been licensed for commercial use by the NFT holder/artist, and all users who mint and hold this NFT can use it for commercial purposes.",
            "The work can be permanently used for commercial purposes.",
            "You can submit your own products to the SuperBrands NFT Brand Library (soon) by verifying this NFT on SuperBrands."
        ]
        return <div className="detail-page-container">
            <BackToPreviousPage/>
            <div className="flex-row detail-content">
                <div className="nft-image-container">
                    <div className="nft-image" style={{ backgroundImage: `url(${nftBg})` }}>
                        {
                            mintIPInfo.licensedNFT ?
                                <img  className="image-item"
                                      src={mintIPInfo.licensedNFTImage}
                                    alt="" />  :
                                <Swiper slidesPerView={1}
                                        loop
                                        autoplay={{
                                            delay: 3000
                                        }}
                                        modules={[Autoplay, Pagination]}
                                        pagination={{clickable: true}}
                                        className="info-swiper"
                                >
                                    <SwiperSlide key={1} className="img-swiper-item">
                                        <div>
                                            <img src={mintIPInfo.derivativeMintInfo?.image} className="image-item"
                                                 alt=""/>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide key={2} className="img-swiper-item">
                                        <div>
                                            <img src={mintIPInfo.derivativeMintInfo?.originalImage}
                                                 className="image-item" alt=""/>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                        }
                    </div>
                </div>
                <div className="nft-info flex-col">
                    <div>
                        <p className="nft-name">{mintIPInfo.licensedNFT ? handleNFTName(mintIPInfo.licenseCollectionName, mintIPInfo.licensedNFTokenId) : mintIPInfo.derivativeMintInfo?.name}</p>
                        <Space size={40} className="info-space" wrap>
                            {mintIPInfo.licensedNFT ? "" :
                                <div className="flex-row">
                                    <img src={mintIPInfo.artist?.avatar} className="info-img" alt="" />
                                    <div className="info-text">
                                        {/* <p>{mintIPInfo.licenseCollectionName}</p> */}
                                        <p>Artist</p>
                                        <p>{mintIPInfo.artist?.name}</p>
                                    </div>
                                </div>
                            }
                            <div className="flex-row">
                                <img src={mintIPInfo.licensedNFTImage} className="info-img" alt="" />
                                <div className="info-text">
                                    <p>Licensed IP</p>
                                    <p>{mintIPInfo.licenseCollectionName} #{mintIPInfo.licensedNFTokenId}</p>
                                </div>
                            </div>
                            <div className="flex-row">
                                <img src={mintIPInfo.licenseCollectionLogo} className="info-img" alt="" />
                                <div className="info-text">
                                    <p>Collection</p>
                                    <p>{mintIPInfo.licenseCollectionName}</p>
                                </div>
                            </div>
                        </Space>
                        {mintIPInfo.status === LicensedNFTStatus.UNLICENSED ?
                            unlicensedTips.map((item, i) => (
                                <div className="flex-row tips-item" key={i}>
                                    <CheckCircleFilled />
                                    <p>{item}</p>
                                </div>
                            )) : licensedTips.map((item, i) => (
                                <div className="flex-row tips-item" key={i}>
                                    <CheckCircleFilled />
                                    <p>{item}</p>
                                </div>
                            ))
                        }
                    </div >
                    {/* <div className="validity-container">
                        <span className="bold">The validity period of copyright:</span>
                        {
                            mintIPInfo.licensedNFT ?
                                <span className="bold">{mintIPInfo.licensingPeriod}</span> :
                                <span className="btn-golden">Permanent</span>
                        }
                    </div> */}
                    {
                        mintIPInfo.licensedNFT || mintIPInfo.derivativeMintInfo?.status === DerivativeWorkStatus.UNISSUED ?
                            this.renderLock() : this.renderPurchase()
                    }

                </div >
            </div >
            {/* <div className="tip-public"><CheckCircleFilled style={{ fontSize: "18px", color: "#34c759" }} /> <span>Authorized to SuperBrands public copyright market</span>
            </div>
            <div className="myth-panel info-panel">
                <Tabs defaultActiveKey="1" className="myth-tabs">
                    <TabPane tab="Copyright information" key="1">
                        <CopyRightContent copyrightInfo={copyrightInfo} />
                    </TabPane>
                    <TabPane tab="Authorization description" key="2">
                        Content of Tab Pane 2
                    </TabPane>
                    <TabPane tab="Profit distribution" key="3">
                        Content of Tab Pane 3
                    </TabPane>
                </Tabs>
            </div>*/}
        </div >
    }
}

export default MintIPInfo;
